import { defaultMakePropertyPrefix } from './defaultMakePropertyPrefix';
export var defaultMakeValueClass = function defaultMakeValueClass(propertyPrefix, value) {
  return "".concat(propertyPrefix, "_").concat(value);
};
export var baseSetClass = function baseSetClass(element, prefix, makePropertyPrefix, makeValueClass, property, value) {
  var classesForRemove = [];
  var propertyPrefix = makePropertyPrefix(prefix, property);
  Array.prototype.forEach.call(element.classList, function (className) {
    if (className.startsWith(propertyPrefix)) {
      classesForRemove.push(className);
    }
  });
  classesForRemove.forEach(function (className) {
    element.classList.remove(className);
  });
  element.classList.add(makeValueClass(propertyPrefix, value));
};
export var defaultSetClass = function defaultSetClass(element, property, value) {
  baseSetClass(element, 'n3__wcag', defaultMakePropertyPrefix, defaultMakeValueClass, property, value);
};